// extracted by mini-css-extract-plugin
export default {"pageTitle":"styles_pageTitle__h3LzV"};